import { useTranslate, useDelete, useNavigation, useModal } from "@refinedev/core";

// It is recommended to use explicit import as seen below to reduce bundle size.
// import { IconName } from "@ant-design/icons";
import * as Icons from "@ant-design/icons";

import { Dropdown, Menu, Modal, Spin } from "antd";
import { ICredential, IOrder } from "interfaces";
import { useState } from "react";

const { FormOutlined, FolderViewOutlined, DeleteOutlined } = Icons;

type CredentialActionProps = {
  record: ICredential;
};

export const CredentialActions: React.FC<CredentialActionProps> = ({ record }) => {
  const { mutate } = useDelete();

  const [isDeleting, setIsDeleting] = useState(false);

  const deleteOrder = (id: any) => {
    setIsDeleting(true);

    mutate({
      resource: "credentials",
      id,
    }, {
      onSettled: () => setIsDeleting(false)
    });
  };

  const { visible: isDeleteModalVisible, show: showDeleteModal, close: closeDeleteModal } = useModal();

  const { edit, show } = useNavigation();
  const moreMenu = (record: ICredential) => (
    <Menu
      mode="vertical"
      onClick={({ domEvent }) => domEvent.stopPropagation()}
    >
      <Menu.Item
        key="2"
        style={{
          fontWeight: 500,
        }}
        icon={
          <FormOutlined
            style={{
              color: "green",
            }}
          />
        }
        onClick={() => edit("credentials", record.id)}
      >
        Edit Credential
      </Menu.Item>
      <Menu.Item
        key="3"
        style={{
          fontWeight: 500,
        }}
        icon={
          <DeleteOutlined
            style={{
              color: "red",
            }}
          />
        }
        onClick={showDeleteModal}
      >
        Delete Credential
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Modal
        title="Delete Credential"
        open={isDeleteModalVisible}
        onCancel={closeDeleteModal}
        okButtonProps={{
          style: { backgroundColor: "red", width: 70 }
        }}
        okText={
          isDeleting
            ? <Spin indicator={<Icons.LoadingOutlined spin style={{ color: "#fff" }} />} />
            : "Delete"
        }
        onOk={() => {
          deleteOrder(record.id);
        }}
      >
        Are you sure you want to delete credential for <b>{record.url}</b>?
      </Modal>
      <Dropdown overlay={moreMenu(record)} trigger={["click"]}>
        <Icons.MoreOutlined
          onClick={(e) => e.stopPropagation()}
          style={{
            fontSize: 24,
          }}
        />
      </Dropdown>
    </>
  );
};
